export const translations = {
    // 中文
    zh: {
        // 通用
        loading: "加载中...",
        confirm: "确认",
        cancel: "取消",
        save: "保存",
        delete: "删除",
        back: "返回",
        submit: "提交",
        success: "成功",
        error: "错误",
        warning: "警告",
        projectInitReason: "工程初始化",
        projectInitComment: "系统自动生成的起始任务量",

        // 登录页面
        loginTitle: "家庭积分系统",
        loginSubtitle: "登录您的账户",
        email: "邮箱",
        password: "密码",
        loginButton: "立即登录",
        loggingIn: "登录中...",
        noAccount: "还没有账户？",
        registerNow: "立即注册",
        enterEmail: "请输入您的邮箱",
        enterPassword: "请输入您的密码",
        loginFailed: "登录失败，请重试",

        // 注册页面
        registerTitle: "创建账户",
        registerSubtitle: "加入我们的家庭积分系统",
        confirmPassword: "确认密码",
        confirmPasswordPlaceholder: "请再次输入密码",
        passwordMismatch: "两次输入的密码不一致",
        passwordTooShort: "密码长度至少为6位",
        registerButton: "立即注册",
        registering: "注册中...",
        registerFailed: "注册失败",
        registerSuccess: "注册成功！即将跳转到登录页面...",
        enterNickname: "请输入您的昵称",
        nickname: "昵称",
        alreadyHaveAccount: "已有账户？",
        loginHere: "立即登录",
        networkError: "网络错误，请重试",

        // 导航栏
        apply: "申报",
        profile: "个人中心",

        // Dashboard
        currentPoints: "当前积分",
        pendingPoints: "当前待完成总量",
        recentChanges: "最近变动明细",
        noRecords: "暂无变动记录",
        noProject: "尚未创建工程",
        noProjectHint: "点击下方按钮开始管理你的第一个家庭积分项目",
        createProject: "立即创建新工程",
        switchProject: "切换其他工程",
        newProject: "新建积分工程",
        confirmDelete: "确认撤回并删除该记录吗？",
        confirmAction: "确认此操作吗？",
        actionFailed: "操作失败",
        pending: "待确认",
        rejected: "已驳回",
        confirmed: "已确认",
        noComment: "无备注",
        pendingStatus: "待入账...",
        balance: "结余",
        reject: "驳回",
        withdraw: "撤回",
        supervisor: "监督者",
        performer: "执行人",
        supervisorRole: "监督者",
        performerRole: "执行者",

        // 工程相关
        positiveMode: "正分",
        negativeMode: "负分",
        positiveSystem: "正分系统",
        negativeSystem: "负分系统",
        positiveSystemDesc: "积攒分值换奖励",
        negativeSystemDesc: "消除待办任务量",
        projectTitle: "工程名称",
        createProjectTitle: "新建积分工程",
        editProjectTitle: "工程管理设置",
        projectNotExist: "工程不存在",
        paramError: "参数错误",

        // AddLog 申报页面
        applyTitle: "申报积分记录",
        reason: "变动事由",
        selectReason: "-- 请选择事由 --",
        customReason: "自定义新事由...",
        enterCustomReason: "请输入自定义事由名称",
        customReasonPlaceholder: "例如：额外帮妈妈擦窗户",
        changeValue: "分值变动",
        pointsHint: "分值",
        negativeHint: "⚠️ 负分系统：增加数值 (+) 代表债务增加，减少数值 (-) 代表销账",
        positiveHint: "💡 正分系统：增加数值 (+) 代表获得积分",
        comment: "详细说明 (选填)",
        commentPlaceholder: "有什么想补充的吗？",
        businessTime: "发生时间",
        submitSuccess: "✅ 申报成功",
        submitFailed: "❌ 错误：",
        networkFailed: "网络连接失败",
        selectOrInputReason: "请选择或输入事由",
        enterCustomReasonName: "请输入自定义事由名称",

        // CreateProject 创建工程
        basicInfo: "基本信息",
        performerEmail: "指派执行者 (Email)",
        performerEmailHint: "对方必须已在本系统注册账号",
        modeAndRules: "模式与规则",
        selectMode: "选择系统模式",
        initialPoints: "设定初始分值",
        initialPointsHint: "系统将以此数值作为统计起点",
        creating: "正在创建...",
        confirmCreate: "确认创建工程",
        projectCreated: "✅ 工程创建成功！",
        createFailed: "❌ 失败：",
        networkErrorCreate: "网络连接异常",
        projectNamePlaceholder: "如：家务销账计划",
        emailPlaceholder: "输入对方的注册邮箱...",

        // EditProject 工程设置
        basicConfig: "基础配置",
        systemMode: "系统模式",
        positive: "正分系统",
        negative: "负分系统",
        incentiveMode: "激励模式",
        taskMode: "任务模式",
        saveBasicConfig: "保存基础配置",
        basicConfigUpdated: "✅ 基础配置已更新",
        configUpdateFailed: "更新失败",
        requestFailed: "请求失败",
        presetConfig: "事由与分值预设",
        addPreset: "+ 添加预设项",
        syncPresets: "同步预设至云端",
        presetsSynced: "🍃 预设已同步至云端",
        savePresetFailed: "保存失败",
        dangerZone: "危险区域",
        dangerZoneHint: "工程关闭后将不再出现在列表和个人中心，且无法撤销此操作。",
        closeProject: "永久关闭并存档此工程",
        confirmCloseTitle: "确定要关闭此工程吗？",
        confirmCloseMsg: "关闭后：\n1. 执行者将看不到此工程\n2. 无法再进行新的申报\n3. 数据将作为历史记录保留在后台",
        confirmCloseFinal: "这是最后一次确认，真的要关闭吗？",
        projectClosed: "✅ 工程已关闭",

        // Profile 个人中心
        userInfo: "用户信息",
        selectNewAvatar: "选择新头像",
        editNickname: "修改",
        vipUser: "VIP 用户",
        upgradeToVip: "升级为VIP用户",
        upgradeVipHint: "VIP用户可以创建无限数量的工程项目！",
        upgrading: "处理中...",
        upgradeSuccess: "升级成功",
        upgradeFailed: "升级失败",
        noProductsAvailable: "暂无可用产品",
        purchaseError: "购买失败，请重试",
        relatedProjects: "关联的项目",
        noProjectRelated: "暂无工程",
        logout: "退出登录并切换账号",
        confirmLogout: "确定要退出登录并切换账号吗？",
        networkErrorLogout: "网络错误",
        identity: "身份",
        performerIdentity: "执行人",
        supervisorIdentity: "",
        reInvite: "需要重新指定",
        performerEmailPlaceholder: "输入执行者邮箱",
        updateFailed: "更新失败",
        vipOnlyFeature: "此为VIP用户高级功能",
        projectStats: "工程统计",
        projectStatsTitle: "工程统计分析",
        period_week: "一周",
        period_month: "一月",
        period_year: "一年",
        period_all: "总计",
        summary: "数据概要",
        totalRecords: "总记录数",
        totalPoints: "总分数",
        totalPositive: "总正分",
        totalNegative: "总负分",
        reasonByCount: "按次数统计",
        reasonDistribution: "事由分布",
        positiveDistribution: "正分分布",
        negativeDistribution: "负分分布",
        trendChart: "趋势图",
        dailyCount: "日增总量",
        noData: "暂无数据",
        loadingFailed: "加载失败",
        pendingInvites: "待确认的邀请",
        moreInvites: "还有 {count} 个",
        inviteYouToProject: "邀请你执行工程 ",
        accept: "接受",

        inviteAcceptSuccess: "已接受邀请",
        inviteRejectSuccess: "已拒绝邀请",

        // 语言
        language: "语言",
        switchLanguage: "切换语言",
    },

    // 英文
    en: {
        // Common
        loading: "Loading...",
        confirm: "Confirm",
        cancel: "Cancel",
        save: "Save",
        delete: "Delete",
        back: "Back",
        submit: "Submit",
        success: "Success",
        error: "Error",
        warning: "Warning",
        projectInitReason: "Project Initialization",
        projectInitComment: "Automatically generated starting task amount",

        // Login
        loginTitle: "Family Points System",
        loginSubtitle: "Sign in to your account",
        email: "Email",
        password: "Password",
        loginButton: "Sign In",
        loggingIn: "Signing in...",
        noAccount: "Don't have an account?",
        registerNow: "Register now",
        enterEmail: "Enter your email",
        enterPassword: "Enter your password",
        loginFailed: "Login failed, please try again",

        // Register Page
        registerTitle: "Create Account",
        registerSubtitle: "Join our Family Points System",
        confirmPassword: "Confirm Password",
        confirmPasswordPlaceholder: "Please enter your password again",
        passwordMismatch: "Passwords do not match",
        passwordTooShort: "Password must be at least 6 characters long",
        registerButton: "Register Now",
        registering: "Registering...",
        registerFailed: "Registration failed",
        registerSuccess: "Registration successful! Redirecting to login...",
        enterNickname: "Please enter your nickname",
        nickname: "Nickname",
        alreadyHaveAccount: "Already have an account?",
        loginHere: "Login here",
        networkError: "Network error, please try again",

        // Navigation
        apply: "Apply",
        profile: "Profile",

        // Dashboard
        currentPoints: "Current Points",
        pendingPoints: "Total Pending",
        recentChanges: "Recent Changes",
        noRecords: "No records yet",
        noProject: "No Project Yet",
        noProjectHint: "Click the button below to start managing your first family points project",
        createProject: "Create New Project",
        switchProject: "Switch Project",
        newProject: "New Project",
        confirmDelete: "Are you sure you want to withdraw and delete this record?",
        confirmAction: "Are you sure you want to proceed?",
        actionFailed: "Operation failed",
        pending: "Pending",
        rejected: "Rejected",
        confirmed: "Confirmed",
        noComment: "No comment",
        pendingStatus: "Pending...",
        balance: "Balance",
        reject: "Reject",
        withdraw: "Withdraw",
        supervisor: "Supervisor",
        performer: "Performer",
        supervisorRole: "Supervisor",
        performerRole: "Performer",

        // Project
        positiveMode: "Positive",
        negativeMode: "Negative",
        positiveSystem: "Positive System",
        negativeSystem: "Negative System",
        positiveSystemDesc: "Earn points for rewards",
        negativeSystemDesc: "Eliminate pending tasks",
        projectTitle: "Project Name",
        createProjectTitle: "Create New Project",
        editProjectTitle: "Project Settings",
        projectNotExist: "Project does not exist",
        paramError: "Parameter error",

        // AddLog
        applyTitle: "Apply Points Record",
        reason: "Reason",
        selectReason: "-- Select reason --",
        customReason: "Custom reason...",
        enterCustomReason: "Enter custom reason name",
        customReasonPlaceholder: "e.g., Extra help with cleaning windows",
        changeValue: "Points Change",
        pointsHint: "Points",
        negativeHint: "⚠️ Negative system: Increase (+) adds debt, decrease (-) reduces debt",
        positiveHint: "💡 Positive system: Increase (+) earns points",
        comment: "Details (optional)",
        commentPlaceholder: "Anything to add?",
        businessTime: "Transaction Time",
        submitSuccess: "✅ Application submitted successfully",
        submitFailed: "❌ Error:",
        networkFailed: "Network connection failed",
        selectOrInputReason: "Please select or enter a reason",
        enterCustomReasonName: "Please enter custom reason name",

        // CreateProject
        basicInfo: "Basic Information",
        performerEmail: "Assign Performer (Email)",
        performerEmailHint: "The person must have registered an account in this system",
        modeAndRules: "Mode & Rules",
        selectMode: "Select System Mode",
        initialPoints: "Initial Points",
        initialPointsHint: "This will be the starting value for statistics",
        creating: "Creating...",
        confirmCreate: "Create Project",
        projectCreated: "✅ Project created successfully!",
        createFailed: "❌ Failed:",
        networkErrorCreate: "Network connection error",
        projectNamePlaceholder: "e.g., Household chores plan",
        emailPlaceholder: "Enter performer's registered email...",

        // EditProject
        basicConfig: "Basic Settings",
        systemMode: "System Mode",
        positive: "Positive System",
        negative: "Negative System",
        incentiveMode: "Incentive Mode",
        taskMode: "Task Mode",
        saveBasicConfig: "Save Settings",
        basicConfigUpdated: "✅ Settings updated",
        configUpdateFailed: "Update failed",
        requestFailed: "Request failed",
        presetConfig: "Reason & Points Presets",
        addPreset: "+ Add Preset",
        syncPresets: "Sync Presets to Cloud",
        presetsSynced: "🍃 Presets synced to cloud",
        savePresetFailed: "Save failed",
        dangerZone: "Danger Zone",
        dangerZoneHint: "Once closed, the project will no longer appear in the list and cannot be undone.",
        closeProject: "Permanently Close & Archive",
        confirmCloseTitle: "Are you sure you want to close this project?",
        confirmCloseMsg: "After closing:\n1. Performer will not see this project\n2. No new applications can be made\n3. Data will be kept as historical records",
        confirmCloseFinal: "This is the final confirmation. Really close?",
        projectClosed: "✅ Project closed",

        // Profile
        userInfo: "User Info",
        selectNewAvatar: "Select New Avatar",
        editNickname: "Edit",
        vipUser: "VIP User",
        upgradeToVip: "Upgrade to VIP",
        upgradeVipHint: "VIP users can create unlimited projects!",
        upgrading: "Processing...",
        upgradeSuccess: "Upgrade successful",
        upgradeFailed: "Upgrade failed",
        noProductsAvailable: "No products available",
        purchaseError: "Purchase failed, please try again",
        relatedProjects: "Related Projects",
        noProjectRelated: "No projects",
        logout: "Logout & Switch Account",
        confirmLogout: "Are you sure you want to logout and switch accounts?",
        networkErrorLogout: "Network error",
        identity: "Role",
        performerIdentity: "Performer",
        supervisorIdentity: "Supervisor",
        reInvite: "Need to re-assign",
        performerEmailPlaceholder: "Enter performer email",
        updateFailed: "Update failed",
        vipOnlyFeature: "This is a VIP user premium feature",
        projectStats: "Statistics",
        projectStatsTitle: "Project Statistics",
        period_week: "Week",
        period_month: "Month",
        period_year: "Year",
        period_all: "All",
        summary: "Summary",
        totalRecords: "Total Records",
        totalPoints: "Total Points",
        totalPositive: "Total Positive",
        totalNegative: "Total Negative",
        reasonByCount: "By Count",
        reasonDistribution: "Reason Distribution",
        positiveDistribution: "Positive Distribution",
        negativeDistribution: "Negative Distribution",
        trendChart: "Trend Chart",
        dailyCount: "Daily cumulative total",
        noData: "No data",
        loadingFailed: "Failed to load",
        pendingInvites: "Pending Invitations",
        moreInvites: "{count} more",
        inviteYouToProject: "invites you to project ",
        accept: "Accept",

        inviteAcceptSuccess: "Invitation accepted",
        inviteRejectSuccess: "Invitation rejected",

        // Language
        language: "Language",
        switchLanguage: "Switch Language",
    },

    // 日文
    ja: {
        // 共通
        loading: "読み込み中...",
        confirm: "確認",
        cancel: "キャンセル",
        save: "保存",
        delete: "削除",
        back: "戻る",
        submit: "送信",
        success: "成功",
        error: "エラー",
        warning: "警告",
        projectInitReason: "プロジェクト初期化",
        projectInitComment: "システム自動生成の開始タスク量",

        // ログイン
        loginTitle: "ファミリーーポイント制度",
        loginSubtitle: "アカウントにログイン",
        email: "メールアドレス",
        password: "パスワード",
        loginButton: "ログイン",
        loggingIn: "ログイン中...",
        noAccount: "アカウントをお持ちでないですか？",
        registerNow: "今すぐ登録",
        enterEmail: "メールアドレスを入力",
        enterPassword: "パスワードを入力",
        loginFailed: "ログインに失敗しました。もう一度お試しください",

        // 登録ページ
        registerTitle: "アカウント作成",
        registerSubtitle: "ファミリーポィートシステムへようこそ",
        confirmPassword: "パスワード確認",
        confirmPasswordPlaceholder: "もう一度パスワードを入力してください",
        passwordMismatch: "パスワードが一致しません",
        passwordTooShort: "パスワードは6文字以上である必要があります",
        registerButton: "今すぐ登録",
        registering: "登録中...",
        registerFailed: "登録に失敗しました",
        registerSuccess: "登録成功！ログインページにリダイレクトします...",
        enterNickname: "ニックネームを入力してください",
        nickname: "ニックネーム",
        alreadyHaveAccount: "すでにアカウントをお持ちですか？",
        loginHere: "ログインはこちら",
        networkError: "ネットワークエラー。もう一度お試しください",

        // ナビゲーション
        apply: "申請",
        profile: "プロフィール",

        // ダッシュボード
        currentPoints: "現在のポイント",
        pendingPoints: "未完了の合計",
        recentChanges: "最近の変動",
        noRecords: "記録がありません",
        noProject: "プロジェクトがありません",
        noProjectHint: "下のボタンをクリックして、最初のファミリーポイントプロジェクトの 管理を始めましょう",
        createProject: "新規プロジェクト作成",
        switchProject: "プロジェクト切替",
        newProject: "新規プロジェクト",
        confirmDelete: "この記録を撤回・削除してもよろしいですか？",
        confirmAction: "この操作を実行しますか？",
        actionFailed: "操作に失敗しました",
        pending: "保留中",
        rejected: "却下",
        confirmed: "承認済み",
        noComment: "コメントなし",
        pendingStatus: "処理待ち...",
        balance: "残高",
        reject: "却下",
        withdraw: "撤回",
        supervisor: "管理者",
        performer: "実行者",
        supervisorRole: "スーパーバイザー",
        performerRole: "パフォーマー",

        // プロジェクト
        positiveMode: "ポジティブ",
        negativeMode: "ネガティブ",
        positiveSystem: "ポジティブシステム",
        negativeSystem: "ネガティブシステム",
        positiveSystemDesc: "ポイントをためて報酬と交換",
        negativeSystemDesc: "未完了タスクを消去",
        projectTitle: "プロジェクト名",
        createProjectTitle: "新規プロジェクト作成",
        editProjectTitle: "プロジェクト設定",
        projectNotExist: "プロジェクトが存在しません",
        paramError: "パラメータエラー",

        // AddLog
        applyTitle: "ポイント記録を申請",
        reason: "変動理由",
        selectReason: "-- 理由を選択 --",
        customReason: "カスタム理由...",
        enterCustomReason: "カスタム理由名を入力",
        customReasonPlaceholder: "例：窓掃除をお手伝い",
        changeValue: "ポイント変動",
        pointsHint: "ポイント",
        negativeHint: "⚠️ ネガティブシステム：増加(+)で負債増加、減少(-)で負債返済",
        positiveHint: "💡 ポジティブシステム：増加(+)でポイント獲得",
        comment: "詳細（任意）",
        commentPlaceholder: "补充することがありますか？",
        businessTime: "発生日時",
        submitSuccess: "✅ 申請に成功しました",
        submitFailed: "❌ エラー：",
        networkFailed: "ネットワーク接続に失敗しました",
        selectOrInputReason: "理由を選択または入力してください",
        enterCustomReasonName: "カスタム理由名を入力してください",

        // CreateProject
        basicInfo: "基本情報",
        performerEmail: "実行者を指定 (Email)",
        performerEmailHint: "相手は当システムにを登録している必要があります",
        modeAndRules: "モードとルール",
        selectMode: "システムモードを選択",
        initialPoints: "初期ポイント設定",
        initialPointsHint: "これが統計の起点となります",
        creating: "作成中...",
        confirmCreate: "プロジェクト作成",
        projectCreated: "✅ プロジェクトが作成されました！",
        createFailed: "❌ 失敗：",
        networkErrorCreate: "ネットワーク接続エラー",
        projectNamePlaceholder: "例：家事返済プラン",
        emailPlaceholder: "相手の登録メールアドレスを入力...",

        // EditProject
        basicConfig: "基本設定",
        systemMode: "システムモード",
        positive: "ポジティブシステム",
        negative: "ネガティブシステム",
        incentiveMode: "インセンティブモード",
        taskMode: "タスクモード",
        saveBasicConfig: "設定を保存",
        basicConfigUpdated: "✅ 設定が更新されました",
        configUpdateFailed: "更新に失敗しました",
        requestFailed: "リクエストに失敗しました",
        presetConfig: "理由とポイントのプレセット",
        addPreset: "+ プレセット追加",
        syncPresets: "プレセットをクラウドに同期",
        presetsSynced: "🍃 プレセットがクラウドに同期されました",
        savePresetFailed: "保存に失敗しました",
        dangerZone: "危険ゾーン",
        dangerZoneHint: "閉鎖後、プロジェクトはリストに表示されなくなり、元に戻せません。",
        closeProject: "永久閉鎖・アーカイブ",
        confirmCloseTitle: "このプロジェクトを閉鎖してもよろしいですか？",
        confirmCloseMsg: "閉鎖後：\n1. 実行者がプロジェクトを見れなくなります\n2. 新規申請ができなくなります\n3. データは履歴として保持されます",
        confirmCloseFinal: "最終確認です。本当に閉鎖しますか？",
        projectClosed: "✅ プロジェクトが閉鎖されました",

        // Profile
        userInfo: "ユーザー情報",
        selectNewAvatar: "新しいアバターを選択",
        editNickname: "編集",
        vipUser: "VIPユーザー",
        upgradeToVip: "VIPにアップグレード",
        upgradeVipHint: "VIPユーザーは無制限のプロジェクトを作成できます！",
        upgrading: "処理中...",
        upgradeSuccess: "アップグレード成功",
        upgradeFailed: "アップグレード失敗",
        noProductsAvailable: "利用可能な製品がありません",
        purchaseError: "購入に失敗しました。もう一度お試しください",
        relatedProjects: "関連プロジェクト",
        noProjectRelated: "プロジェクトなし",
        logout: "ログアウト・アカウント切替",
        confirmLogout: "ログアウトしてアカウントを切り替えますか？",
        networkErrorLogout: "ネットワークエラー",
        identity: "立場",
        performerIdentity: "パフォーマー",
        supervisorIdentity: "スーパーバイザー",
        reInvite: "再指定が必要",
        performerEmailPlaceholder: "パフォーマーのメールアドレスを入力",
        updateFailed: "更新に失敗しました",
        vipOnlyFeature: "これはVIPユーザー限定機能です",
        projectStats: "統計",
        projectStatsTitle: "プロジェクト統計分析",
        period_week: "週",
        period_month: "月",
        period_year: "年",
        period_all: "全部",
        summary: "データ概要",
        totalRecords: "総記録数",
        totalPoints: "総ポイント",
        totalPositive: "総正ポイント",
        totalNegative: "総負ポイント",
        reasonByCount: "回数別",
        reasonDistribution: "理由分布",
        positiveDistribution: "正分布",
        negativeDistribution: "負分布",
        trendChart: "トレンドチャート",
        dailyCount: "日別累計",
        noData: "データなし",
        loadingFailed: "読み込み失敗",
        pendingInvites: "確認待ちの招待",
        moreInvites: "さらに {count} 件",
        inviteYouToProject: "さんがあなたをプロジェクトに招待しています: ",
        accept: "承認",

        inviteAcceptSuccess: "招待を承認しました",
        inviteRejectSuccess: "招待を拒否しました",

        // 言語
        language: "言語",
        switchLanguage: "言語を切替",
    },
};

// 语言信息配置
export const languages = [
    { code: "zh", name: "中文", flag: "🇨🇳", nativeName: "中文" },
    { code: "en", name: "English", flag: "🇺🇸", nativeName: "English" },
    { code: "ja", name: "日本語", flag: "🇯🇵", nativeName: "日本語" },
];

export const defaultLanguage = "zh";
